import { useContext, useEffect } from "react"
import { AuthContext } from "../../context/Auth/AuthContext"
import { SocketContext } from "../../context/Socket/SocketContext"
import { useSituacaoStore } from "../../stores/situacaoStore"
import { prefetchSituacoesPagina } from "../../hooks/useSituacoesQueries/prefetchSituacoesPagina"

const SituacaoSocketInitializer = () => {
  const { user: oUsuario } = useContext(AuthContext)
  const oGerenciadorSocket = useContext(SocketContext)

  useEffect(() => {
    if (!oUsuario?.companyId) return

    prefetchSituacoesPagina()

    const cEmpresaId = String(oUsuario.companyId)
    const oSocket = oGerenciadorSocket.getSocket(cEmpresaId)
    const oSocketBruto = oSocket.rawSocket || oSocket

    const situacaoEventoTratar = (oDados) => {
      useSituacaoStore.getState().eventoSocketAplicar(oDados)
    }

    const oJaConectou = { lValor: false }
    const reconexaoTratar = () => {
      if (oJaConectou.lValor && oSocketBruto.recovered === false) {
        useSituacaoStore.getState().invalidarTudo()
      }
      oJaConectou.lValor = true
    }

    oSocket.on("situacao", situacaoEventoTratar)
    oSocketBruto.on("connect", reconexaoTratar)

    return () => {
      oSocket.off("situacao", situacaoEventoTratar)
      oSocketBruto.off("connect", reconexaoTratar)
      oSocket.disconnect()
    }
  }, [oGerenciadorSocket, oUsuario?.companyId])

  return null
}

export default SituacaoSocketInitializer
